import React from 'react';
import MeterProductPage from '../meter-product-page';

import bgImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_background.png';
import logoImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_logo_white.png';
import qrImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_qr_code.jpg';
import productImg from '../../../assets/product-interaction/joys500/joys500_product.png';

const JOYS500 = () => (
  <MeterProductPage
    documentTitle="JOYS500｜光电直读水表"
    bgImg={bgImg}
    logoImg={logoImg}
    productImg={productImg}
    productImageStyle={{ width: '790px', height: '790px', left: '103px', top: '0' }}
    qrImg={qrImg}
    model="JOYS500"
    productName="光电直读水表"
    slogan="光电直读 · 稳定采集"
    tags={['M-Bus', 'RS485']}
    manualUrl="http://m.joymeter.com/manual?code=JOYS500-700-001"
    wiringUrl="/product/joys500/installation"
    secondaryTitle="查看安装说明"
    secondarySubtitle="INSTALLATION · 点击查看 →"
    secondaryLinkTitle="查看 JOYS500 安装与接线说明"
  />
);

export default JOYS500;
